import * as service from "../service";
import { store } from "../../store";
import { controlLoading } from "../../slices/app.slice";
import type { ServiceResponse } from "../types";

type GetSponsorsByUserParams = {
  page?: number;
};

type SponsorItem = Record<string, any>;

type GetSponsorsByUserResult = {
  sponsors: SponsorItem[];
  total: number;
  page: number;
  pageSize: number;
};

/**
 * Fetch sponsors created by the currently logged-in business user.
 * Backend: GET /api/sponsor/byUser/:userId (uses req.auth.userId, URL param ignored)
 */
export const GetSponsorsByUserAPI = async ({
  page,
}: GetSponsorsByUserParams = {}): Promise<
  ServiceResponse<GetSponsorsByUserResult>
> => {
  const { business } = store.getState().auth as any;
  try {
    const resp = (await service.call(
      "GET",
      `api/sponsor/byUser/${business?.user_id}`,
      {
        ...(page !== undefined ? { page } : {}),
      },
    )) as ServiceResponse<GetSponsorsByUserResult>;
    if (resp?.status === 0) {
      store.dispatch(controlLoading({ showLoading: false }));
    }
    return resp;
  } catch (err) {
    console.error(`GetSponsorsByUserAPI ${err}`);
    return { status: -1, error: err };
  }
};

export type GetSponsorTasksByUserParams = {
  userId: string;
  page?: number;
  pageSize?: number;
};

export type SponsorTask = {
  id: string;
  name: string;
  description?: string;
  completed: boolean;
  deadline?: string | null;
  review_count?: number;
  proof?: any;
  queue_job_status?: string | null;
  sponsor_activity_id?: string | null;
  sponsor_task_type?: string | null;
  compensation_receipt_url?: string | null;
  compensation_amount?: number | null;
  compensation_approval_status?: string | null;
  compensation_reject_reason?: string | null;
};

export type GetSponsorTasksByUserResult = {
  resp: SponsorTask[];
  total: number;
  page: number;
  pageSize: number;
  status: number;
};

/**
 * Get paginated sponsor tasks for a user (admin only).
 * Backend: GET /api/sponsor/byUser/:userId/tasks?page=1&pageSize=10
 */
export const GetSponsorTasksByUserAPI = async (
  params: GetSponsorTasksByUserParams,
): Promise<GetSponsorTasksByUserResult | { status: -1; error: any }> => {
  try {
    const { userId, page = 1, pageSize = 10 } = params;
    const resp = (await service.call(
      "GET",
      `/api/sponsor/byUser/${userId}/tasks`,
      { page, pageSize },
    )) as GetSponsorTasksByUserResult;
    if (resp?.status === 0) {
      store.dispatch(controlLoading({ showLoading: false }));
    }
    return resp;
  } catch (err) {
    console.error(`GetSponsorTasksByUserAPI ${err}`);
    return { status: -1, error: err };
  }
};